import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./Modal.module.css";
import classNames from "classnames";

/**
 * Basic layout for modals used in the app
 */

export function Modal({ isOpen, children, className, onClose }) { // 1. Added onClose
  return (
    <>
      {isOpen && (
        <div className={styles.overlay} onClick={onClose}> {/* 2. Close when background is clicked */}
          <div 
            className={classNames(styles.container, className)} 
            onClick={(e) => e.stopPropagation()} // 3. Prevent clicks inside from closing it
          >
            {children}
          </div>
        </div>
      )}
    </>
  );
}

Modal.propTypes = {
  /**
   * A string title of the modal
   */
  title: PropTypes.string,
  /**
   * Boolean to determine if modal is open
   */
  isOpen: PropTypes.bool,
  /**
   * Children components to render in the modal
   */
  children: PropTypes.any,
  /**
   * Passed in to make changes to the modal style
   */
  className: PropTypes.string,
};
